// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__17fUv","bigColWidth":"Table_bigColWidth__3Lam2","biggerColWidth":"Table_biggerColWidth__2UjXP","row":"Table_row__2sULY","col":"Table_col__34ket"};